import { render, staticRenderFns } from "./CruiseDetailCabin.vue?vue&type=template&id=489fa664&scoped=true&"
import script from "./CruiseDetailCabin.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailCabin.vue?vue&type=script&lang=js&"
import style0 from "./CruiseDetailCabin.vue?vue&type=style&index=0&id=489fa664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fa664",
  null
  
)

export default component.exports